import { ErrorsType } from "..";
import { Custom } from "./Custom";

interface Props {
    tasOccurrenceNumber?: string;
    isLoading: boolean;
    subject?: string;
    customerComment: string;
    handleChangeComment: (comment: string) => void;
    errors: ErrorsType;
    partOrComponentName: string;
    handlePartOrComponentName: (value: string) => void;
    partNumber: string;
    handlePartNumber: (value: string) => void;
    problemDescription: string;
    handleProblemDescription: (value: string) => void;
    diagnosticAndResults: string;
    handleDiagnosticAndResults: (value: string) => void;
    problemSteps: string;
    handleProblemSteps: (value: string) => void;
    failureFrequency: string;
    handleFailureFrequency: (value: string) => void;
}

const AdditionalDataTas = ({
    tasOccurrenceNumber,
    isLoading,
    customerComment,
    handleChangeComment,
    subject,
    errors,
    partOrComponentName,
    handlePartOrComponentName,
    partNumber,
    handlePartNumber,
    problemDescription,
    handleProblemDescription,
    diagnosticAndResults,
    handleDiagnosticAndResults,
    problemSteps,
    handleProblemSteps,
    failureFrequency,
    handleFailureFrequency
}: Props) => {

    const supportTypesWithProblemSteps = [
        'GEARBOX',
        'CHASSIS',
        'SUPPORT_AXLE',
        'FRONT_AXLE',
        'CLUTCH',
        'ENGINE',
        'E_DELIVERY',
        'WHEEL',
        'STEERING_SYSTEM',
        'BRAKE_SYSTEM',
        'ELECTRICAL_SYSTEM',
        'DRIVE_AXLE',
        'SUSPENSION',
        'POWER_TAKEOFF',
        'TRANSMISSION',
    ];

    const shouldShowProblemSteps = supportTypesWithProblemSteps.includes(subject as string);

    return (
        <div className="width-100pct height-100pct border rounded padding-15">
            <div className="margin-bottom-15">
                <span className="text-size-14 text-medium text-color-black">2. Dados adicionais</span>
            </div>
            <div className="width-100pct display-flex flex-row gap-20">
                {/* <Custom.Input label='Número do contrato*' value={tasOccurrenceNumber} disabled={true} isLoading={isLoading} /> */}

                <Custom.Input
                    label='Nome da Peça ou Componente'
                    value={partOrComponentName}
                    isLoading={isLoading}
                    onChange={handlePartOrComponentName}
                    error={errors.partOrComponentName}
                    placeholder="Opcional"
                />
                <Custom.Input
                    label='Nº da peça VW/MAN'
                    value={partNumber}
                    isLoading={isLoading}
                    onChange={handlePartNumber}
                    error={errors.partNumber}
                    placeholder="Opcional"
                />
            </div>


            {subject === 'ENGINE_REPLACEMENT_REQUEST' || subject === 'TAS_DIAGNOSIS_TOOLS' ? null : (
                <div className="width-100pct">
                    <Custom.TextArea
                        label={"Qual a reclamação do cliente?"}
                        value={customerComment}
                        onChange={handleChangeComment}
                        isLoading={isLoading}
                        error={errors.customerComment}
                        placeholder="Opcional"
                    />
                </div>
            )}

            {subject === 'ENGINE' ? (
                <Custom.TextArea
                    label={"Em qual frequência a falha ocorre?"}
                    value={failureFrequency}
                    onChange={handleFailureFrequency}
                    isLoading={isLoading}
                    error={errors.failureFrequency}
                    placeholder="Opcional"
                />
            ) : null}

            {subject === 'CABIN' || subject === 'ENGINE_REPLACEMENT_REQUEST' || subject === 'TAS_DIAGNOSIS_TOOLS' ? (
                <div className="width-100pct">
                    <Custom.TextArea
                        label={"O que aconteceu?"}
                        value={problemDescription}
                        onChange={handleProblemDescription}
                        isLoading={isLoading}
                        error={errors.problemDescription}
                        placeholder="Opcional"
                    />
                </div>
            ) : null}

            {shouldShowProblemSteps ? (
                <div className="width-100pct">
                    <Custom.TextArea
                        label={"É possível reproduzir? Informe o passo-a-passo."}
                        value={problemSteps}
                        onChange={handleProblemSteps}
                        isLoading={isLoading}
                        error={errors.problemSteps}
                        placeholder="Opcional"
                    />
                </div>
            ) : null}

            {subject === 'SOFTWARE_IDLE_AUTO_SHUTDOWN' ? null : (
                <div className="width-100pct">
                    <Custom.TextArea
                        label={"Relate procedimentos de diagnóstico e resultados"}
                        value={diagnosticAndResults}
                        onChange={handleDiagnosticAndResults}
                        isLoading={isLoading}
                        error={errors.diagnosticAndResults}
                        placeholder="Opcional"
                    />
                </div>
            )}
        </div >
    )
}

export default AdditionalDataTas;